/* eslint-disable @typescript-eslint/no-explicit-any */
type TrackType =
  | 'AddPaymentInfo'
  | 'AddToCart'
  | 'AddToWishlist'
  | 'CompleteRegistration'
  | 'Contact'
  | 'CustomizeProduct'
  | 'Donate'
  | 'FindLocation'
  | 'InitiateCheckout'
  | 'Lead'
  | 'Purchase'
  | 'Schedule'
  | 'Search'
  | 'StartTrial'
  | 'SubmitApplication'
  | 'Subscribe'
  | 'ViewContent'
  | 'PageView'

export const track = (trackType: TrackType, options?: any) => {
  if (typeof window !== 'undefined' && 'fbq' in window) {
    if (options) (window as any).fbq('track', trackType, options)
    else (window as any).fbq('track', trackType)

    return true
  }

  return false
}

export const trackCustom = <T extends string>(trackType: T, options?: any) => {
  if (typeof window !== 'undefined' && 'fbq' in window) {
    if (options) (window as any).fbq('trackCustom', trackType, options)
    else (window as any).fbq('trackCustom', trackType)

    return true
  }

  return false
}
